import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoTi: CultureInfo = {
  name: 'ti',
  displayName: 'Tigrinya',
  iso3LanguageCode: 'tir',
  iso2LanguageCode: 'ti',
  ietfLanguageTag: 'ti',
  parent: null
};
